import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/car-rental.js";
import "@ui5/webcomponents-icons/dist/employee.js";
import "@ui5/webcomponents-icons/dist/database.js";
import "@ui5/webcomponents-icons/dist/wrench.js";
import "@ui5/webcomponents-icons/dist/alert.js";
import "@ui5/webcomponents-icons/dist/business-objects-experience.js";
import "@ui5/webcomponents-icons/dist/card.js";
import "@ui5/webcomponents-icons/dist/document-text.js";
import "@ui5/webcomponents-icons/dist/shipping-status.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { fleetPermissions, fleetSettingsGroup } from "./permissions";

/** Fleet entries of the navigation registry (group `fleet`, docs/contracts/fleet.md §5). */
export const fleetNavigation: readonly NavigationEntry[] = [
  {
    key: "fleet.vehicles",
    labelKey: "nav.fleetVehicles",
    icon: "car-rental",
    path: "/fleet/vehicles",
    permission: fleetPermissions.vehicleView,
  },
  {
    key: "fleet.drivers",
    labelKey: "nav.fleetDrivers",
    icon: "employee",
    path: "/fleet/drivers",
    permission: fleetPermissions.driverView,
  },
  {
    key: "fleet.fuel",
    labelKey: "nav.fleetFuel",
    icon: "database",
    path: "/fleet/fuel",
    permission: fleetPermissions.fuelView,
  },
  {
    key: "fleet.maintenance",
    labelKey: "nav.fleetMaintenance",
    icon: "wrench",
    path: "/fleet/maintenance",
    permission: fleetPermissions.maintenanceView,
  },
  {
    key: "fleet.alerts",
    labelKey: "nav.fleetAlerts",
    icon: "alert",
    path: "/fleet/alerts",
    permission: fleetPermissions.vehicleView,
  },
  {
    key: "fleet.reports",
    labelKey: "nav.fleetReports",
    icon: "business-objects-experience",
    path: "/fleet/reports",
    permission: fleetPermissions.reportView,
  },
  {
    key: "fleet.carCards",
    subGroup: "carCards",
    labelKey: "nav.fleetCarCards",
    icon: "card",
    path: "/fleet/car-cards",
    permission: fleetPermissions.carCardView,
  },
  {
    key: "fleet.garageOrders",
    subGroup: "carCards",
    labelKey: "nav.fleetGarageOrders",
    icon: "document-text",
    path: "/fleet/garage-orders",
    permission: fleetPermissions.garageOrderView,
  },
  {
    key: "fleet.clearances",
    subGroup: "carCards",
    labelKey: "nav.fleetClearances",
    icon: "shipping-status",
    path: "/fleet/clearances",
    permission: fleetPermissions.clearanceView,
  },
  {
    key: "fleet.settings",
    labelKey: "nav.fleetSettings",
    icon: "settings",
    path: `/platform/settings/${fleetSettingsGroup}`,
    permission: fleetPermissions.setupView,
  },
];
